export enum TagPrismicPorProducto {
  ProductoProteccionDigitalPersonas = 'proteccion-digital-personas',
  SOAT = 'soat',
  ProductoSoat = 'soat',
  ProductoSoatRauc = 'soat-renovacion',
  ProductoViajesInternacional = 'viajes',
  ProductoViajesNacional = 'viajes',
  ProductoViajesMov = 'viajes',
  ProductoMascotas = 'mascotas',
  ProductoAutos = 'autos',
  ProductoAutosCotizador = 'autos',
  ProductoSaludDigital = 'salud',
  ProductoRenovacionSaludDigital = 'salud',
  ProductoRecargaSaludDigital = 'salud',
  ProductoVida = 'vida',
  ProductoArrendamientos = 'arrendamiento-digital',
  ProductoRenovacionArrendamientos = 'arrendamiento-renovacion',
  ProductoDeportistas = 'deportistas',
  ProductoPac = 'pac-digital',
  MOTOSDIGITAL = 'motos-digital',
  AUTOSDIGITAL = 'autos-digital',
  ARRENDAMIENTODIGITAL = 'arrendamiento-digital',
  VIAJESDIGITAL = 'viajes-digital',
}
